import React from 'react';

export const LoadingSkeleton: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="w-[calc(100%-32px)] md:w-[760px] mx-auto relative pt-4 md:pt-8 px-4 md:px-0 animate-pulse">
        {/* 헤더 스켈레톤 */}
        <div className="mt-4 md:mt-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-0">
            <div className="h-8 md:h-9 bg-gray-200 rounded w-64 md:w-80"></div>
            <div className="h-6 md:h-8 bg-gray-200 rounded w-28 md:w-32"></div>
          </div>
          <div className="w-full h-px mt-4 md:mt-8 bg-gray-200"></div>
          <div className="mt-4 md:mt-8 flex items-center justify-between">
            <div className="h-8 md:h-9 bg-gray-200 rounded w-40 md:w-48"></div>
            <div className="h-10 md:h-11 bg-gray-200 rounded w-24 md:w-32"></div>
          </div>
        </div>

        <div className="w-full h-px mt-6 md:mt-8 bg-gray-200"></div>

        {/* 신청자 정보 스켈레톤 */}
        <div className="mt-6 md:mt-8 bg-white rounded-sm border border-gray-200">
          <div className="p-4 md:p-8">
            <div className="h-6 md:h-7 bg-gray-200 rounded w-28 md:w-32 mb-3 md:mb-4"></div>
            <div className="w-full md:w-[calc(100%-64px)] h-px bg-gray-200 mb-6 md:mb-8"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {[1, 2, 3, 4].map((i) => (
                <div key={i}>
                  <div className="h-4 md:h-5 bg-gray-200 rounded w-16 md:w-20 mb-2"></div>
                  <div className="h-10 md:h-12 bg-gray-200 rounded w-full"></div>
                </div>
              ))}
            </div>
          </div>

          {/* 제출 서류 스켈레톤 */}
          <div className="p-4 md:p-8">
            <div className="h-6 md:h-7 bg-gray-200 rounded w-28 md:w-32 mb-3 md:mb-4"></div>
            <div className="w-full md:w-[calc(100%-64px)] h-px bg-gray-200 mb-6 md:mb-8"></div>
            <div className="space-y-3 md:space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4">
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-200 rounded"></div>
                    <div className="h-4 md:h-5 bg-gray-200 rounded w-40 md:w-48"></div>
                  </div>
                  <div className="h-9 md:h-10 bg-gray-200 rounded w-20 md:w-24"></div>
                </div>
              ))}
            </div>
          </div>

          {/* 추가 요청사항 스켈레톤 */}
          <div className="p-4 md:p-8">
            <div className="h-6 md:h-7 bg-gray-200 rounded w-28 md:w-32 mb-3 md:mb-4"></div>
            <div className="w-full md:w-[calc(100%-64px)] h-px bg-gray-200 mb-6 md:mb-8"></div>
            <div className="h-28 md:h-36 bg-gray-200 rounded w-full"></div>
          </div>
        </div>

        {/* 신청 일시 스켈레톤 */}
        <div className="mt-6 md:mt-8 mb-24 md:mb-28">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-0">
            <div>
              <div className="h-4 md:h-5 bg-gray-200 rounded w-16 md:w-20 mb-1 md:mb-2"></div>
              <div className="h-4 md:h-5 bg-gray-200 rounded w-40 md:w-48"></div>
            </div>
            <div>
              <div className="h-4 md:h-5 bg-gray-200 rounded w-16 md:w-20 mb-1 md:mb-2"></div>
              <div className="h-4 md:h-5 bg-gray-200 rounded w-40 md:w-48"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
